<div class="banner-container" [ngStyle]="{ 'margin-top': !showIcons ? '50px' : '15px'}">
  <img class="circle-left" src="./assets/home/security/left-circle.svg" alt="">
  <img class="circle-right" src="./assets/home/security/right-circle.svg" alt="">
  <div class="information">
    <div class="txt">
      <div class="container-txt">
        <p class="tittle">Seguridad</p>
        <h2 [ngStyle]="{'color': showIcons ? '#4A4A4A' : '#007e85'}">Tu seguridad nos <br class="skip-line">
          importa, y mucho</h2>
        <p class="sub-tittle">Nuestro servicio cuenta
          con los
          mismos
          estándares de seguridad que la banca más
          avanzada y con la
          garantía de compañías europeas que nos avalan.</p>
        <button *ngIf="!button" (click)="goToUrl()" class="btn">Conoce mas</button>
        <div *ngIf="button" class="icons">
          <p class="garanty">NUESTRA GARANTÍA DE CONFIANZA Y SEGURIDAD</p>
          <div class="icons-container">
            <div>
              <a target="_blank"
                href="https://eur-lex.europa.eu/legal-content/ES/TXT/HTML/?uri=CELEX:32015L2366&qid=1610532238138&from=EN">
                <img src="./assets/home/security/1.svg" alt="" aria-label="Reglamento eIDAS">
              </a>
              <a target="_blank" href="https://www.entrust.net/customer/profile?domain=akana.es&lang=en">
                <img style="width: 70px;" src="./assets/home/security/2.svg" alt="" aria-label="Certificado de confianza">
              </a>
            </div>
            <div>
              <a target="_blank" href="https://www.entrust.com/resources/certificate-solutions/learn/faq">
                <img src="./assets/home/security/3.svg" alt="" aria-label="FAQ">
              </a>
              <a target="_blank" href="https://www.bde.es/bde/es/areas/supervision/funcion/Entidades/Entidades_supervisadas.html">
                <img src="./assets/home/security/bde.png" alt="" aria-label="Banco de España">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boy">
      <img class="boy-img" src="./assets/home/security/boy.svg" alt="">
    </div>
  </div>
</div>
